module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "app-chip",
    class: {
      active: _vm.isActive
    }
  }, [_c('input', _vm._b({
    staticClass: "visually-hidden",
    attrs: {
      "type": "checkbox",
      "name": _vm.name,
      "id": _vm.inputId
    },
    domProps: {
      "checked": _vm.isActive,
      "value": _vm.item.id
    },
    on: {
      "change": function($event) {
        return _vm.$emit('toggle', _vm.item.id)
      }
    }
  }, 'input', _vm.$attrs, false)), _vm._v("\n  " + _vm._s(_vm.item.text) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d4381e74","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppChip/AppChip.vue
// module id = e90bcaaa8143c54b9540
// module chunks = 12